import { render, staticRenderFns } from "./Cotiza.vue?vue&type=template&id=15bc19fd&"
import script from "./Cotiza.vue?vue&type=script&lang=js&"
export * from "./Cotiza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports